import axios from "axios";

export default {
  namespaced: true,
  state: {
    planillas: null
  },
  mutations: {
    setPlanillas(state, data) {
      state.planillas = data;
    }
  },
  actions: {
    async fetchPlanillas({ state, commit }) {
      if (state.planillas) return state.planillas;
      const response = await axios.get("api/boxscores");
      const planillas = response.data;
      commit("setPlanillas", planillas);
      return planillas;
    }
  }
}